import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Personnel Space Assignment: The association(s) between personnel and space.',
    name: 'Personnel Space Assignments',
    partialId: PartialId.Standard.create('person_space'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
